/* created by CoolGuy on 2019/4/3 */
import {combineReducers} from "redux";
import AjaxAction from "../actions/AjaxAction";

const currentRateList = (state = [], action)=>{
  switch (action.type) {
    case AjaxAction.RATE_LIST: {
      if(action.data && action.data.data) {
        action.data.data = action.data.data.filter(Boolean).map(it=>{
          let {consult_paper_detail = []} = it;
          let images = [];
          // 投诉
          let complaint = [];
          // 整体服务说明
          let whole_service = [];
          consult_paper_detail.filter(Boolean).forEach(paper=>{
            try {
              let raw = JSON.parse(paper.context_raw);
              raw.forEach(answer=>{
                if(answer && answer.type == 'file' && answer.id == '127') {
                  try {
                    images = images.concat(JSON.parse(answer.value));
                  }catch(err) {

                  }
                }
                if(answer && answer.type == 'textarea' && answer.id == '100') { // 投诉
                  complaint.push(answer.value);
                }
                if(answer && answer.type == 'textarea' && answer.id == '121') { // 整体服务说明
                  whole_service.push(answer.value);
                }
              })
            }catch(e) {

            }
          });

          it.adviser_images = images || [];
          it.complaint = complaint;
          it.whole_service = whole_service;
          
          return it;
        });
      }
      return action.data;
    }
    default:
      return state;
  }
}
const currentRateRelatedInfo = (state = {}, action)=>{
    const {obj} = action;
    switch (action.type) {
        case AjaxAction.RATE_INFO:
            return {
                ...state,
                ...obj,
            }
        default:
            return state;
    }
}
const currentRateDetailList = (state = Array(8), action)=>{
    const {questionnaire_id} = action;
    switch (action.type) {
        case AjaxAction.RATE_DETAIL:
            return [
                ...state.slice(0, +questionnaire_id),
                action.data,
                ...state.slice(+questionnaire_id+1),
            ];
        case AjaxAction.RATE_DETAIL_EMPTY:
            return Array(8);
        default:
            return state;
    }
}
const staffRateList = (state={},action)=>{
    switch (action.type) {
        case AjaxAction.RATE_STAFF_RATE_LIST:
            const {data} = action.data || {};
            const theData = data.map(one=>{
                const {id, answer_op} = one;
                // 这个接口因为id不是唯一值，所以不得不联合了2个字段
                one.uniId = `${id}-${answer_op}`;
                return one;
            });
            return theData;
        default:
            return state;
    }
}
const ratedList = (state = {}, action)=>{
    switch (action.type) {
        case AjaxAction.RATE_RATED_LIST:
            return action.data;
        default:
            return state;
    }
}
const unRatedList = (state = {},action)=>{
    switch (action.type) {
        case AjaxAction.RATE_UNRATE_LIST:
            return action.data;
        default:
            return state;
    }
}

const staffTodoList = (state = [], action)=>{
    switch(action.type) {
        case AjaxAction.RATE_STAFF_TODO:
            return action.data;
        default:
            return state;
    }
}

const staffScoreDetail = (state = [], action)=>{
    switch (action.type) {
        case AjaxAction.RATE_SCORE_DETAIL:
            return action.data;
        default:
            return state;
    }
}
const staffScoreDetailDetail = (state = [], action)=>{
    switch (action.type) {
        case AjaxAction.RATE_SCORE_DETAIL_DETAIL:
            return action.data;
        default:
            return state;
    }
}
// 员工得分 详情中的'综合'
const staffScoreSum = (state = {}, action)=>{
    switch (action.type) {
        case AjaxAction.RATE_STAFF_SCORE_LIST_DETAIL_SUM:
            return action.data;
        default:
            return state;
    }
}
// 员工得分 详情中的列表项
const staffScoreList = (state={}, action)=>{
    const {op} = action;
    switch (action.type) {
        case AjaxAction.RATE_STAFF_SCORE_LIST_DETAIL_LIST:
            return {
                ...state,
                [op]:action.data,
            }
        default:
            return state;
    }
}
//员工得分 当前点击的详情项
const staffScoreCurrent = (state = {}, action)=>{
    switch (action.type) {
        case AjaxAction.RATE_STAFF_SCORE_CURRENT:
            return action.data;
        default:
            return state;
    }
}

const staffScore = combineReducers({
    staffScoreSum,
    staffScoreList,
})
const currentRateReducer = combineReducers({
    list: currentRateList,
    currentRateDetailList,
    currentRateRelatedInfo,
})
export default {
    currentRate: currentRateReducer,
    staffRateList,
    staffScoreDetail,
    staffScoreDetailDetail,
    staffScoreCurrent,
    ratedList, // 已评价的列表
    unRatedList, // 未评价列表
    staffTodoList, // 评价链接列表
    staffScore, // 员工得分接口 相关。里边包含的当前员工得分接口的综合 和 其他列表
}



// WEBPACK FOOTER //
// ./src/reducers/rateReducer.js